import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { routes } from '../utils/routeConfig';

export interface AppRouteType {
  component: React.ElementType;
  layout: React.ElementType;
  isAuthProtected: boolean;
}

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}: AppRouteType) => {
  const location = useLocation();
  const token = localStorage.getItem('token');

  if (isAuthProtected && !token) {
    return <Navigate to={routes.login} state={location} />;
  } else if (location.pathname === routes.login && token) {
    return <Navigate to={routes.dashboard} state={location} />;
  }

  return (
    <Layout>
      <Component {...rest} />
    </Layout>
  );
};
export default AppRoute;
